export enum PageRoutes {
  Negotiations = '/negotiations',
  Offer = '/offer',
  FileGeneratorOffer = '/file-generator-offer',
  Pyaterochka = '/pyaterochka',
  Perekrestok = '/perekrestok',
  Chizhik = '/chizhik',
  EsiaCallback = '/esia/callback', //TODO:? изменить путь на /esia-callback
  Liveness = '/liveness',
  CreateCandidate = '/create-candidate',
}
